import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { colorCoreBlack900Base, colorCoreGray500 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const TagsStyled = styled(FlexWrapper) `
  margin: 0 32px;
  padding: 24px 0;
  border-top: 1px solid ${colorCoreGray500};
  border-bottom: 1px solid ${colorCoreGray500};

  ${ADAPTIVE.minWidth.tablet} {
    margin: 0 48px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin: 0 96px;
  }
`;
export const TagStyled = styled(Link) `
  cursor: pointer;
  padding: 4px 12px;
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.xs};

  ${getTextStyles('Ubuntu', 400, 14, 20)};

  color: ${colorCoreBlack900Base};
  text-decoration: none;
`;
